/* eslint-disable max-len */
const productsMock = [
  {
    "id": 1865888,
    "primaryImage": "https://img-new.cgtrader.com/items/1865888/b3b76339eb/large/spacesuit-orange-aces-3d-model-b3b76339eb.webp",
    "title": "SPACESUIT Orange ACES",
    "price": 40,
    "finalPrice": 20,
    "formats": [
      ".max",
      ".obj",
      ".fbx",
      ".c4d",
      ".blend",
      ".abc",
    ],
    "types": {
      "printReady": false,
      "animated": false,
      "pbr": true,
      "rigged": false,
    },
    "percentage": 50,
    "slug": "/3d-models/character/sci-fi-character/aces-nasa-space-suit",
  },
  {
    "id": 685652,
    "primaryImage": "https://img-new.cgtrader.com/items/685652/39a747f851/large/crystal-model-kit-6-types-3d-model-39a747f851.webp",
    "title": "Crystal Model Kit - 6 Types",
    "price": 29,
    "finalPrice": 14.5,
    "formats": [
      ".obj",
      ".fbx",
      ".blend",
      ".dae",
    ],
    "types": {
      "printReady": false,
      "animated": false,
      "pbr": true,
      "rigged": false,
    },
    "percentage": 50,
    "slug": "/3d-models/architectural/decoration/crystal-model-kit-trigonal-system",
  },
  {
    "id": 2987019,
    "primaryImage": "https://img-new.cgtrader.com/items/2987019/ab9a9500cb/large/scifi-building-futuristic-building-3d-model-ab9a9500cb.webp",
    "title": "Scifi building  futuristic building",
    "price": 30,
    "finalPrice": 30,
    "formats": [
      ".max",
      ".obj",
      ".fbx",
      ".ma",
      ".blend",
      ".uasset",
    ],
    "types": {
      "printReady": false,
      "animated": false,
      "pbr": true,
      "rigged": false,
    },
    "percentage": 0,
    "slug": "/3d-models/exterior/sci-fi-exterior/scifi-building-futuristic-building",
  },
  {
    "id": 3812296,
    "primaryImage": "https://img-new.cgtrader.com/items/3812296/0658aa0e06/large/sikorsky-uh-60-black-hawk-plus-7-skins-3d-model-0658aa0e06.webp",
    "title": "Sikorsky UH-60 Black Hawk plus 7 Skins",
    "price": 39.99,
    "finalPrice": 12,
    "formats": [
      ".obj",
      ".fbx",
      ".blend",
    ],
    "types": {
      "printReady": false,
      "animated": false,
      "pbr": true,
      "rigged": false,
    },
    "percentage": 69.99,
    "slug": "/3d-models/aircraft/military-aircraft/sikorsky-uh-60-black-hawk-plus-7-skins",
  },
  {
    "id": 1904772,
    "primaryImage": "https://img-new.cgtrader.com/items/1904772/e58007f657/large/spacesuit-silver-mercury-navy-mark-iv-3d-model-e58007f657.webp",
    "title": "SPACESUIT Silver Mercury Navy Mark IV",
    "price": 40,
    "finalPrice": 20,
    "formats": [
      ".max",
      ".obj",
      ".fbx",
      ".blend",
      ".abc",
    ],
    "types": {
      "printReady": false,
      "animated": false,
      "pbr": true,
      "rigged": false,
    },
    "percentage": 50,
    "slug": "/3d-models/character/sci-fi-character/mercury-navy-mark-iv-space-suit",
  },
  {
    "id": 4112932,
    "primaryImage": "https://img-new.cgtrader.com/items/4112932/abfa7f6ffe/large/atlantic-ocean-cliff-coast-line-scan-pbr-3d-model-abfa7f6ffe.webp",
    "title": "Atlantic Ocean Cliff Coast Line Scan PBR",
    "price": 120,
    "finalPrice": 60,
    "formats": [
      ".obj",
      ".fbx",
      ".blend",
      ".png",
      ".jpg",
    ],
    "types": {
      "printReady": false,
      "animated": false,
      "pbr": true,
      "rigged": false,
    },
    "percentage": 50,
    "slug": "/3d-model-collections/atlantic-ocean-cliff-coast-line-scan-pbr",
  },
  {
    "id": 2650443,
    "primaryImage": "https://img-new.cgtrader.com/items/2650443/85f9f2346a/large/sci-fi-industrial-base-unreal-project-3d-model-85f9f2346a.webp",
    "title": "Sci-Fi Industrial Base - Unreal project",
    "price": 75,
    "finalPrice": 37.5,
    "formats": [
      ".fbx",
      ".uasset",
    ],
    "types": {
      "printReady": false,
      "animated": false,
      "pbr": true,
      "rigged": false,
    },
    "percentage": 50,
    "slug": "/3d-models/exterior/sci-fi-exterior/sci-fi-industrial-base-unreal-project",
  },
  {
    "id": 2662714,
    "primaryImage": "https://img-new.cgtrader.com/items/2662714/87298e5d16/large/classic-style-porch-house-with-furniture-3d-model-87298e5d16.webp",
    "title": "Classic style porch house with furniture",
    "price": 45,
    "finalPrice": 13.5,
    "formats": [
      ".obj",
      ".fbx",
      ".stl",
      ".blend",
      ".dae",
      ".abc",
    ],
    "types": {
      "printReady": false,
      "animated": false,
      "pbr": true,
      "rigged": false,
    },
    "percentage": 70,
    "slug": "/3d-models/interior/house-interior/classic-style-porch-house-with-furniture",
  },
  {
    "id": 3719028,
    "primaryImage": "https://img-new.cgtrader.com/items/3719028/a6ae212f3a/large/architectural-kitbash-vol-01-02-03-04-05-3d-model-a6ae212f3a.webp",
    "title": "ARCHITECTURAL KITBASH - VOL 01 - 02 - 03 - 04 - 05",
    "price": 35,
    "finalPrice": 17.5,
    "formats": [
      ".max",
      ".obj",
      ".3ds",
      ".fbx",
      ".stl",
      ".dwg",
    ],
    "types": {
      "printReady": false,
      "animated": false,
      "pbr": false,
      "rigged": false,
    },
    "percentage": 50,
    "slug": "/3d-model-collections/architectural-kitbash-vol-1-and-2",
  },
  {
    "id": 2503689,
    "primaryImage": "https://img-new.cgtrader.com/items/2503689/3bcf35e083/large/mandalorian-blaster-pistol-3d-asset-kit-pbr-3d-model-3bcf35e083.webp",
    "title": "Mandalorian Blaster Pistol - 3D Asset Kit PBR ",
    "price": 9,
    "finalPrice": 6.3,
    "formats": [
      ".obj",
      ".fbx",
      ".blend",
    ],
    "types": {
      "printReady": false,
      "animated": false,
      "pbr": true,
      "rigged": false,
    },
    "percentage": 30,
    "slug": "/3d-models/military/gun/mandalorian-blaster-pistol-3d-asset-kit-pbr-9ec12df0-cf25-49de-97cd-cdd5bf6570ba",
  },
]


export const collectionModelsAreaMock = {
  numberOfModels: 15,
  products: productsMock,
  slug: '3d-model-collection',
}
